// ラベルは全 mall 共通の superset。どの type を UI に出すかは
// mall_specific.jsx の PRICE_SETTING_TYPES で mall ごとに決める。
export const LABELS = {
    unspecified: 'サイズ無指定',
    click_post: 'クリックポスト',
    smaller_or_eq_than_60_size: '〜60',
    size_61_to_80: '61〜80',
    smaller_or_eq_than_100_size: '〜100',
    size_101_to_140: '101〜140',
    above_140_size: '141〜',
}